<template>
  <div class="container">
    <div class="my-5">
      <h1 class="text-center">در حال انتقال به سایت هستید .....</h1>
    </div>
  </div>
</template>

<script>
export default {
  name: "RedirectLoading",

}
</script>

<style scoped>

</style>